import CircadiaHalfWidthBarChart from '../../../../components/GraphBox/Components/CircadiaHalfWidthBarChart.tsx';
import CircadiaFullWidthBarChart from '../../../../components/GraphBox/Components/CircadiaFullWidthBarChart.tsx';
import { useSelector } from 'react-redux';
import { selectActiveFilters } from '../../../../redux/slices/filterSlice.ts';
import { selectAccount } from '../../../../redux/slices/accountSlice.ts';
import { useGetAssetsByClientAttributesQuery } from '../../../../api/asset.api.ts';
import {
	CLIENT_ATTRIBUTES_CHART_TITLE,
	CLIENT_ATTRIBUTES_XAXIS_LABEL,
	CLIENT_ATTRIBUTES_YAXIS_LABEL,
} from '../../../../constants/messages.tsx';

interface AssetByClientAttributesChartProps {
	registerExportFn?: (exportFn: () => void) => void;
	fullWidth?: boolean;
}

const AssetByClientAttributesChart = ({
	registerExportFn,
	fullWidth = false,
}: AssetByClientAttributesChartProps) => {
	const activeFilters = useSelector(selectActiveFilters);
	const account = useSelector(selectAccount);

	const accountId = account?.accountId ?? 0;
	const sourceId = account?.sourceId ?? 0;
	const accountTypeCode = account?.accountTypeCode ?? '';

	const { data: assetsByClientAttributes = [] } = useGetAssetsByClientAttributesQuery(
		{ sourceId, accountId, accountTypeCode, filters: activeFilters },
		{ skip: !accountId }
	);

	const chartProps = {
		title: CLIENT_ATTRIBUTES_CHART_TITLE,
		xaxislabel: CLIENT_ATTRIBUTES_XAXIS_LABEL,
		yaxislabel: CLIENT_ATTRIBUTES_YAXIS_LABEL,
		data: assetsByClientAttributes,
		registerExportFn,
	};

	return fullWidth ? (
		<CircadiaFullWidthBarChart {...chartProps} />
	) : (
		<CircadiaHalfWidthBarChart {...chartProps} />
	);
};

export default AssetByClientAttributesChart;
